import React, { useState, useEffect } from "react";
import "./styles.css";

const ToastMessage = ({ message, type }) => {
  const [showSnackbar, setShowSnackbar] = useState(false);

  useEffect(() => {
    if (message) {
      setShowSnackbar(true);
      setTimeout(() => {
        setShowSnackbar(false);
      }, 3000);
    }
  }, [message]);

  return (
    <div>
      {showSnackbar && (
        <div 
          id="snackbar" 
          className={`show ${type}`} // Dynamically add class based on the type (success/error)
        >
          {message}
        </div>
      )}
    </div>
  );
};

export default ToastMessage;
